// extracted by mini-css-extract-plugin
module.exports = {"uppercase":"style__uppercase__kTb0R"};